import React, { useState, useEffect } from 'react';
import banner1 from '../assets/slider/slide1.png';
import banner2 from '../assets/slider/slide2.png';
import banner3 from '../assets/slider/slide3.png';

const sliderImages = [banner1, banner2, banner3];

const bannerTexts = [
  {
    heading: 'Welcome to Universal Academy!',
    subtext: 'Every School Has a Story… Ours is One of Excellence.',
  },
  {
    heading: 'Unlock Your Child’s Potential 🎓',
    subtext: 'Where Passion Meets Purpose in Every Classroom.',
  },
  {
    heading: 'Admissions Open 2025–26',
    subtext: 'Join a Legacy of Leadership, Learning & Values.',
  },
];

const BannerSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 4000); // Slide every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="banner-slider" style={{ position: 'relative', height: '80vh', overflow: 'hidden' }}>
      {sliderImages.map((src, index) => (
        <div
          key={index}
          className={`slide ${index === currentSlide ? 'active' : ''}`}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${src})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: index === currentSlide ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
            zIndex: index === currentSlide ? 2 : 1,
          }}
        >
          <div
            style={{
              background: 'rgba(0,0,0,0.4)',
              color: '#fff',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              textAlign: 'center',
              padding: '20px',
            }}
          >
           <h1
  style={{
    fontSize: '3rem',
    marginBottom: '10px',
    fontWeight: 'bold',
    textShadow: '2px 2px 8px rgba(0,0,0,0.6)',
    animation: 'fadeSlideIn 1s ease-in-out',
  }}
>
  {bannerTexts[currentSlide].heading}
</h1>

<p
  style={{
    fontSize: '1.5rem',
    fontWeight: 500,
    maxWidth: '800px',
    lineHeight: 1.6,
    animation: 'zoomIn 1.5s ease-in-out',
  }}
>
  {bannerTexts[currentSlide].subtext}
</p>

          </div>
        </div>
      ))}

      {/* Dots */}
      <div
        style={{
          position: 'absolute',
          bottom: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '10px',
        }}
      >
        {sliderImages.map((_, idx) => (
          <span
            key={idx}
            onClick={() => setCurrentSlide(idx)}
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: idx === currentSlide ? '#fff' : '#aaa',
              cursor: 'pointer',
            }}
          />
        ))}
      </div>
    </section>
  );
};

export default BannerSlider;
